window.mpb = window.mpb || {};

(function ($) {
  'use strict';

  $.fn.disableTextSelect = function() {
    return this
    .attr('unselectable', 'on')
    .css('user-select', 'none')
    .on('selectstart', false);
  };

  // A simple "lightbox" function based on the jQuery-UI 'dialogue' widget
  // This version takes a url and an optional dataobject, and displays the result of the Ajax call
  $.fn.ajaxLightbox = function(url, options = {}) {
    const $this = $(this);
    let {data, callback, allowClose, isImage, errorCallback} = options;
    if (allowClose === undefined) allowClose = true;
    if (isImage === isImage) isImage = url.match(/\.(jpe?g|png|gif)$/i);

    let $tempOverlay = $('#tempOverlay').first();
    if (!$tempOverlay.length) {
      $tempOverlay = $('<div id="tempOverlay" class="ui-widget-overlay" style="z-index:900;opacity:0">')
        .appendTo($('body'));
    }

    $this.css('float', 'left');
    if (isImage) {
      const $img = $(`<img src="${url}" />`);
      $this.html($img);
      $img[0].complete ?
        afterLoad() : // image already loaded: launch afterLoad() immediately
        $img.one('load', afterLoad); // not loaded, lanuch it async (wait for load)
    } else {
      $this.load(url, data || {}, afterLoad);
    }

    return false;

    function afterLoad (responseText, textStatus, jqXHR) {
      if (textStatus === 'error') {
        if (errorCallback) errorCallback(responseText, jqXHR);
        return;
      }
      const wrapper = $('<div>'),
        scrollLeft = $(document).scrollLeft();
      wrapper
        .append($this)
        .dialog({
          modal: true,
          dialogClass: 'jqModalDialogue',
          open: function(event, ui) {
            wrapper.dialog('option', 'width', wrapper.width() + 'px');
            $tempOverlay.animate({opacity: 0.4}, 200);
            if (typeof callback === 'function') {
              callback(wrapper);
            }
            // re-center the popup in a way that works on iPhones as well
            const $popup = $('.jqModalDialogue'), doc = document.documentElement;
            $popup.css({
              // tslint:disable-next-line:max-line-length
              top : Math.max(10, (window.innerHeight || doc.clientHeight) / 2 - $popup.height() / 2) + $(document).scrollTop(),
              left : Math.max(10, (window.innerWidth || doc.clientWidth) / 2  - $popup.width() / 2) + scrollLeft
            });

          },
          close: function() {
            wrapper.remove();
            $('#tempOverlay').animate({opacity: 0}, 200, function() {
              $('#tempOverlay').remove();
            });
          }
        })
        .click(e => e.stopPropagation())// stop clicks from reaching body and closing the popup
        .parent('.jqModalDialogue').append(allowClose ? $('<a class="close">&times;</a>') : '')
        .focus();
      if (allowClose) {
        $(document).one('click', () => $('.ui-dialog-content').dialog('close'));
      }
    }
  };

  // A simple "lightbox" function based on the jQuery-UI 'dialogue' widget
  // This version takes a DOM or jQuery-wrapped element and displays it
  $.fn.elemLightbox = function(elem) {
    const $tempOverlay = $('<div id="tempOverlay" class="ui-widget-overlay" style="z-index:900;opacity:0">')
      .appendTo($('body'))
      .animate({opacity: 0.4}, 200);
    $(this).css('float', 'left').append(elem);
    const wrapper = $('<div>').append($(this));

    // sometimes the wrapper's width is not adjusted intantaneously,
    // so give 50ms for the browser to calculate the width
    window.setTimeout(function() {
      wrapper
        .dialog({
            modal: true,
            dialogClass: 'jqModalDialogue',
            open: function(event, ui) {
            wrapper.dialog('option', 'width', wrapper.width() + 'px');
            $tempOverlay.css('opacity', 0);
            wrapper.css('min-height', '');
          },
          beforeClose: function() {
            wrapper.remove();
            $tempOverlay.css('opacity', 0.4).animate({opacity: 0}, 200, function() {$(this).remove(); });
          }
        })
        .click(e => e.stopPropagation())// stop clicks from reaching body and closing the popup
        .parent('.jqModalDialogue').append($('<a class="close">&times;</a>'));
      $(document).on('tap click', () => $('.ui-dialog-content').dialog('close'));
    }, 50);

    return false;
  };

}(jQuery));

$(() => { // on document.ready
  'use strict';

  // added this for thickbox-like behavior
  $(document).on('click', 'a.lightbox', function(e) {
    return $('<div>').ajaxLightbox(e.target.href);
  });

  $(document).on('tap click', function (e) {
    const container = $('.login_box'); // both login and password_forgot

    if (!container.is(e.target) // if the target of the click isn't the container...
      && container.has(e.target).length === 0)  { // ... nor a descendant of the container
      container.slideUp();
    }
  });

  mpb.debounce = function (func, wait, immediate) {
    let args, result, thisArg, timeoutId;
    function delayed() {
      timeoutId = null;
      if (!immediate) {
        result = func.apply(thisArg, args);
      }
    }
    return function() {
      const isImmediate = immediate && !timeoutId;
      args = arguments;
      thisArg = this;

      clearTimeout(timeoutId);
      timeoutId = setTimeout(delayed, wait);

      if (isImmediate) {
        result = func.apply(thisArg, args);
      }
      return result;
    };
  }

  function number_format(number, decimals, dec_point, thousands_sep) {
    // discuss or find latest version of this function at: http://phpjs.org/functions/number_format
    number = (number + '').replace(/[^0-9+\-Ee.]/g, '');
    const n = !isFinite(+number) ? 0 : +number,
      prec = !isFinite(+decimals) ? 0 : Math.abs(decimals),
      sep = (typeof thousands_sep === 'undefined') ? ',' : thousands_sep,
      dec = (typeof dec_point === 'undefined') ? '.' : dec_point;
    let s = '';
    const toFixedFix = (_n, _prec) => {
        const k = Math.pow(10, _prec);
        return '' + Math.round(_n * k) / k;
      };
    // Fix for IE parseFloat(0.55).toFixed(0) = 0;
    s = (prec ? toFixedFix(n, prec) : '' + Math.round(n)).split('.');
    if (s[0].length > 3) {
      s[0] = s[0].replace(/\B(?=(?:\d{3})+(?!\d))/g, sep);
    }
    if ((s[1] || '').length < prec) {
      s[1] = s[1] || '';
      s[1] += new Array(prec - s[1].length + 1).join('0');
    }
    return s.join(dec);
  }

  mpb.format_number = format_number;
  function format_number(number, shortZero) {
    const dec = window.mpb.decimal,
      m = window.mpb.milSep,
      lz = dec + '00';
    let z = shortZero ? window.mpb.shortZero : lz;
    if (z === undefined) z = lz;
    // if (shortZero===undefined) debugger;
    // console.log({nb:number,shortZero:shortZero,m:m,z:z});
    return number - Math.floor(number) > 0
      ? number_format(number, 2, dec, m)
      : number_format(number, 0, dec, m) + z;
  }

  // Input default text
  window.check_inputs = function() {
    $('.input_default_text').each(function() {
      if (!this._default_text) {
        this._default_text = this.value;
        if (this.type === 'password') {
          this._text_input = document.createElement('input');

          this._text_input.type = 'text';
          this._text_input.className = this.className;
          this._text_input._text_password = this;
          this._text_input.value = this.value;
          this.value = '';

          $(this).removeClass('default_text');

          $(this._text_input).css({
            'position': 'absolute',
            'top': $(this).position().top + 'px',
            'left': $(this).position().left + 'px',
            'margin-top': '0',
            'display': 'block'
            });

          this.parentNode.appendChild(this._text_input);

          $(this.parentNode).css({'height': $(this.parentNode).outerHeight() + 'px'});

          $(this._text_input).on('focus', function() {
            $(this).css({'display': 'none'});
            $(this._text_password).trigger('focus');
          });

          $(this).on('focus', function() {
            if ( $(this._text_input).css('display') === 'block' ) {
              $(this._text_input).trigger('focus');
            }
          });
          $(this).on('change', function() {
            if ( $(this._text_input).css('display') === 'block' ) {
              $(this._text_input).trigger('focus');
            }
          });


          $(this).on('blur', function() {
            if (this.value === '') {
              $(this._text_input).css({'display': 'block'});
            }
          });

        } else {
          $(this).on('focus', function() {
            if (this.value === this._default_text) {
              $(this).val('').removeClass('default_text');
            }
            return true;
          });
          $(this).on('blur', function() {
            if (this.value === '') {
              $(this).addClass('default_text')
                .val(this._default_text);
            }
            return true;
          });
          }
        }
    });
  };
  window.check_inputs();

  const simple_inputs = function() {
    $('.text.simple').each(function() {
      if (!this._default_text) {
        this._default_text = this.value;

        $(this).on('focus', function() {
          if (this.value === this._default_text) {
            this.value = '';
            $(this).removeClass('default_text');
            }
          return true;
        });
        $(this).on('blur', function() {
          if (this.value === '') {
            $(this).addClass('default_text');
            this.value = this._default_text;
            }
          return true;
        });
        }
    });
  };
  simple_inputs();

  setUpInputSpinners('body');
  // !Spinner
  function setUpInputSpinners(where) {
    const $where = $(where);
    $('.input_spinner .plus', $where).on('tap click', function() {
      const input = $('input', $(this).parent()),
        val = parseInt(input.val(), 10),
        max = parseInt(input.attr('alt'), 10);
      if (val < max) {
        input.val(val + 1).trigger('change');
      }
    }).disableTextSelect();

    $('.input_spinner .minus', $where).on('tap click', function() {
      const input = $('input', $(this).parent()),
        val = parseInt(input.val(), 10);
      if (val > 0) {
        input.val(val - 1).trigger('change');
      }
    }).disableTextSelect();
  }

  $('.products .meta h2 em').each(function() {
    $('.brands img[alt="' + this.innerHTML + '"]').each(function() {
      if ( !this._swapped ) {
        const url = this.src.split('.');
        url[url.length - 2] += '_hover';
        this.src = url.join('.');
        this._swapped = true;
        this._url = this.src;
      }
    });
  });

  // Swap color image
  $('.add-color img').hover(
    function() {
      if ( !this._swapped ) {
        this._url = this.src;
        const url = this.src.split('.');
        url[url.length - 2] += '_hover';
        this.src = url.join('.');
        this._swapped = true;
      }
    },
    function() {
      if ( this.src !== this._url ) {
        this._swapped = false;
      }
      this.src = this._url;
    }
  );

  $('.accordion-menu li').not('.selected').not($('.accordion-menu li.selected li')).each(function() {
    const $thisLI = $(this);
    this._ul = $thisLI.children('ul');
    if (this._ul.length) {
      this._ul_height = this._ul[0].scrollHeight;
      $thisLI.hover(
        function() {
          this._hasmouse = true;
          let targetHeight = this._ul_height;
          $(this._ul).children('li').each(function() {
            targetHeight += (this._targetHeight || 0);
          });
          this._targetHeight = targetHeight;
          this._ul.clearQueue();
          this._ul.queue(function() {
              $(this).animate({'height' : $thisLI[0]._targetHeight + 'px' }, {'duration': 'medium', 'queue': true});
              $(this).dequeue();
            });
          $(this).parents('li').first().mouseenter();
        },
        function() {
          this._hasmouse = false;
          this._targetHeight = 0;
          this._ul.delay(1000)
            .queue(function () {
              $(this).animate({'height': '0px'}, {'duration': 'slow', 'queue': true});
              const $parentLi = $(this).parent().parents('li').first();
              if ($parentLi.length && $parentLi[0]._hasmouse) {
                $parentLi.mouseenter();
              } else  {
                if ($parentLi.length) {
                  $parentLi[0]._ul.animate({'height': '0px'}, {'duration': 'slow', 'queue': true});
                }
              }
              $(this).dequeue();
            });
        });
    }
  });

  $('.image-zoomer').each(function() {
    const full_wrapper = $('.image_full img', this).css('cursor', 'pointer').on('tap click', function() {
      zoom.click();
      return false;
    });


    full_wrapper.parent().on('mousemove', function(ev) {
      if (full_wrapper._zoom) {
        this.scrollLeft =  (ev.pageX - $(this).offset().left) / $(this).outerWidth() * (this.scrollWidth - $(this).outerWidth());
        this.scrollTop =  (ev.pageY - $(this).offset().top) / $(this).outerHeight() * (this.scrollHeight - $(this).outerHeight());
      }
    });

    let loading = document.createElement('div');
    loading = $(loading);
    loading.css({
      'position': 'absolute',
      'top': '0px',
      'left': '0px',
      'padding': '10px',
      'background': '#FFF',
      'display': 'none'
    }).html('loading...');
    full_wrapper.parent().append(loading);


    full_wrapper.load(function() {
      if (full_wrapper._loading) {
        loading.css('display', 'none');
        full_wrapper._zoom = true;
        full_wrapper._loading = false;
        full_wrapper.parent().addClass('zoom');
        full_wrapper.css('cursor', 'crosshair');
      }
    });



    const zoom = $('.zoom_bloc .zoom', this).click(function() {
      if (!full_wrapper._zoom) {
        full_wrapper._loading = true;
        full_wrapper.attr('rel', full_wrapper.attr('src'));
        full_wrapper.attr('src', $(this).attr('rel'));
        full_wrapper.parent().get(0).scrollLeft = 0;
        full_wrapper.parent().get(0).scrollTop = 0;
        // if ( !$.browser.msie && parseInt($.browser.version) != 6,10 )
          loading.css('display', 'block');
        $(this).addClass('minus');
      } else {
        full_wrapper.parent().removeClass('zoom');
        full_wrapper._zoom = false;
        full_wrapper.css('cursor', 'pointer');
        full_wrapper.attr('src', full_wrapper.attr('rel'));
        full_wrapper.parent().get(0).scrollLeft = 0;
        full_wrapper.parent().get(0).scrollTop = 0;
        $(this).removeClass('minus');
      }
      return false;
    });
    // !Zoom
    $('.thumbs a', this).not('.zoom').on('tap click', function() {
      const img = $(this).attr('href');
      const full = $(this).attr('rel');
      full_wrapper.animate({'opacity': 0}, 'fast', null, function() {
        full_wrapper._zoom = false;
        full_wrapper.parent().get(0).scrollLeft = 0;
        full_wrapper.parent().get(0).scrollTop = 0;
        full_wrapper.css('cursor', 'pointer');
        full_wrapper.parent().removeClass('zoom');
        zoom.attr('href', img);
        zoom.attr('rel', full);
        if (!full_wrapper.get(0)._onload) {
          full_wrapper.get(0)._onload = true;
          full_wrapper.load(function() {
            full_wrapper.animate({'opacity': 1}, 'fast');
          });
        }
        full_wrapper.attr('src', img);
      });
      return false;
    });
  });

  // scrolling brands
  (function() {
    // takes care of scrolling the banner after it's been set up by code below
    function brandScroll() {
      const speedFactor = 30, // higher is slower
        $brandUL = $('ul.brands'),
        width = $brandUL.data('scrollWidth'),
        right = parseInt($brandUL.css('right'), 10),
        milsec = (width + right) * speedFactor;
      $brandUL.animate({'right': -width + 'px'}, milsec, 'linear', function() {
        $brandUL.css('right', '0'); // reset
        brandScroll(); // restart
      });
    }
    // setup
    const $ul = $('ul.brands'),
      $li = $ul.children('li'),
      $scroll_images = $li.find('img');
    let scroll_images_loaded = 0;

    $scroll_images.one('load', function() {
      // in chrome/safari, img.width=0 until loaded, so wait until all are loaded
      if (++scroll_images_loaded === $scroll_images.length) {
        let  i, extra, width = 0;
        // now get tot width of images
        $scroll_images.each(function() {
          width += $(this).closest('li').outerWidth();
        });
        // add repeat-li until we've got marque-scroller width
        $ul.width(width).data('scrollWidth', width);
        for (i = 0, extra = 0; extra < $('.marque-scroller').width(); i++) {
          const extra_li = $($li[i % $li.length]);
          $ul.append(extra_li.clone());
          extra += extra_li.outerWidth();
        }


        $('img[x-src-hvr]', $ul)
        // preload hover URL
        .each(function() {
          const $this = $(this);
          // remember normal-URL and hover-URL
          $this.data('normalUrl', $this.attr('src'));
          // preload
          if ($this.attr('x-src-hvr')) {
            $('<img>').attr('src', $this.attr('x-src-hvr'));
          }
        })
        // set hover behavior for pics that have a hover url
        .on({
          mouseenter : function() { $(this).attr('src', $(this).attr('x-src-hvr')); }, // show hover URL
          mouseleave : function() { $(this).attr('src', $(this).data('normalUrl')); } // show normal URL
        });

        // resize <UL> container, and remember original width, which will be used by brandScroll()
        $ul.width(width + extra).data('scrollWidth', width);
        // set hover behavior for scrolling
        if ($ul.attr('x-hoverstopscroll')) {
          $ul.on({
            mouseenter : function() { $ul.stop(); }, // stop scroll
            mouseleave : brandScroll // start scroll
          });
        }
        // start scrolling
        brandScroll();
      }
    }).each(function() {
      // trigger load event in case img was already in cache
      if (this.complete) {
        $(this).load();
      }
    });
  }());


  $('.refer_friend').not('.registered').on('tap click', function() {
    return $('<div class="lightbox_content_wrapper lightbox_content" style="width:300px">')
      .ajaxLightbox('/ajax/refer_friend');
  });

  $('a.frogot_password').on('tap click', function() {
    return $('<div class="lightbox_content_wrapper lightbox_content">')
      .ajaxLightbox('/ajax/forgotten_password');
  });

  $('.submit-to-cart').on('tap click', function() {
    if (!mpb.auth && $(this).hasClass('signin')) {
      if (mpb.login_redir) { // For mobile
        window.location = mpb.login_redir;
      }
    } else {
      $(this).parent().trigger('submit');
    }
    return false;
  });

  $('.frmAddToCart').on('submit', function() {
     getSubmitToCartHandler();
  }); // end $('.frmAddToCart').submit


  function getSubmitToCartHandler (wrapper, closeAtEnd) {
    return function () {
      let errorOptions = false;
      const id = $('#option_id').val(),
        qty = parseInt($('.input_spinner input').val(), 10),
        max = parseInt($('.input_spinner input').attr('alt'), 10),
        $errorDisplay = $('.form-error').hide();
      $('#select_options select').each(function(index) {
        if ($(this).val() === 0) errorOptions = true;
      });

      if (errorOptions) {
        if (closeAtEnd) {
          wrapper.dialog('close');
        } else {
          alert(option_error);
          return false;
        }
      }
      if (qty === 0) {
        if (closeAtEnd) {
          wrapper.dialog('close');
        } else {
          alert(zero_error);
          return false;
        }
      }
      if (qty > max) {
        alert(too_many_error + ' ' + max);
        return false;
      }


      if (qty > 0 && max > 0) {
        $.ajax({
          type : 'POST',
          url : '/ajax/cart/addOptions/' + id,
          data: {qty: qty},
          dataType : 'json'
        }).done(function(data) {
          mpb.topCart.resetTimer();
          mpb.topCart.setAmount(data.total);
          if (closeAtEnd) {
            wrapper.dialog('close');
            return false;
          }
          window.location = $('.submit-to-cartOptions').attr('href');
        }).fail(function(data) {
          const message = JSON.parse(data.responseText).message;
          $errorDisplay.html(message).show();
          return false;
        });
      } else  {
        if (closeAtEnd) {
          wrapper.dialog('close');
          return false;
        }
        window.location = $('.submit-to-cartOptions').attr('href');
      }
      return false;
    };
  }
  // category page add to cart options
  function getOptionChoiceHandler($_cartOptionSelects) {
    return function () {
      const valeur = $(this).val(); // get option value
      const status = $('option:selected', this).attr('alt');
      if (valeur === '0' || status === 3) {
        $('#q').val(0).attr('alt', 0);
        $('.qty_blk').show();
        $('.error').hide();
        return;
      }
      const selected = $.map( $_cartOptionSelects, function(s) { return $(s).val(); } ).join(',');

      // Loading
      if (starting_product_options) {
        // on first load, option data already here
        updateOptions(starting_product_options);
        starting_product_options = false;
      } else {
        // otherwise get options via Ajax
        $('.qty_blk').show();
        $('.error').hide();
        const pid = $('#product_id').val();
        $.ajax({
          type : 'GET',
          url : '/ajax/product/' + pid + '/option/' + selected,
          data: window.mpb.previewInfo,
          dataType : 'json'
        }).done(function(data) {
          const _status = data.status,
            available_qty = parseInt(_status.stock, 10) - (_status.selfQty + _status.otherQty);
          if (available_qty <= 0) {
            const message = _status[_status.selfQty ? 'selfMessage' : 'otherMessage'];
            $('.qty_blk').hide().before("<h3 class='error'>" + message + '</h3>');
            $('#q').val(0);
          } else {
            $('#q').val(1);
          }
          updateOptions(data, _status);

        }).fail(function(data) {

        });
      }
    };
  }

  $('.add-to-cart').on('tap click', function() {

    if (!mpb.auth && $(this).hasClass('signin')) {
      return;
    }

    const id = $(this).attr('rel');
    if (id.substr(0, 1) === '#') {
      const pid = id.substr(1);
      $('<div class="lightbox_content_wrapper lightbox_content" style="width:340px">')
      .ajaxLightbox('/ajax/cart/showOptions/' + pid, {
        callback : function(wrapper) {
          const $_cartOptionSelects = $('#select_options select');
          $('#select_options').on('change', 'select', getOptionChoiceHandler($_cartOptionSelects));
          $($_cartOptionSelects[0]).trigger('change');

          $('.submit-to-cartOptions', wrapper).on('tap click', getSubmitToCartHandler(wrapper));
          $('.continue-shopping', wrapper).on('tap click', getSubmitToCartHandler(wrapper, true));
          /* $('.submit-to-cart', wrapper).on('tap click', getSubmitToCartHandler(wrapper));*/
          setUpInputSpinners(wrapper);
        }
      });
    } else {
      $('<div class="lightbox_content_wrapper lightbox_content" style="width:340px">')
      .ajaxLightbox('/ajax/cart/product/' + id + '/add', {
        data : {qty: 1}
      });
    }
    return false;
  });

  /* email popup */
  $('#popup-btn').on('tap click', function() {
    const email = $("input[name='email']").val();
    mpb.LP.open({data: {email}});
    return false;
  });

  // Options managment for product Page
  function updateOptions(data, status) {
    // maj combos
    // tslint:disable-next-line:forin
    for (let opt_group_id in data.opt) {
      const options = data.opt[opt_group_id];
      const select = $('#option_' + opt_group_id);
      select.html('');
      // tslint:disable-next-line:forin
      for (let opt_id in options) {
        const opt = options[opt_id];
        const opt_val = (opt_id.toString()).replace("'", '');
        const opt_name = opt_val > 0 ? data.status_template[opt[1] - 1].replace('{val}', opt[0]) : opt[0];
        const opt_line = $('<option>')
          .val(opt_val) // opt_val_id
          .html(opt_name) // opt name
          .attr('alt', opt[1])  // status
          .attr('selected', opt[2] ? 'selected' : null) // opt_val_id
          .appendTo(select);
      }
    }

    // mise à jour stock
    status = data.status;
    if (status) {
      $('#current_price').html(status.price);
      $('#current_retail').html(status.retail);
      $('#q').attr('alt', parseInt(status.stock, 10) - (status.selfQty + status.otherQty));
      $('#option_id').val(status.id);
    }

    // Changement de l'image
    if (data.image) {
      const img = changeImageOption(
        '/images/product/main/image' + data.image.id + '.' + data.image.imagetype,
        '/images/product/zoom/image' + data.image.id + '.' + data.image.imagetype
      );
    } else {
      const first_thumb = $('.thumbs a').first();
      changeImageOption(
        first_thumb.attr('href'),
        first_thumb.attr('rel')
      );
    }

    $('#loader').hide();
  }

  // product page options
  const $cartOptionSelects = $('#select_options select');
  $('#select_options').on('change', 'select', function() {
    let valeur = $(this).val(); // Récup de la valeur
    const status = $('option:selected', this).attr('alt');
      if (valeur === '0' || status === 3) {
        $('#q').val(0).attr('alt', 0);
        $('.quantity').show();
        $('.stockError').hide();
        valeur = (0
          ? $('.error').show()
          : $('.stockError').hide());
        return;
      }
    const selected = $.map( $cartOptionSelects, function(s) { return $(s).val(); } ).join(',');

    // Loading
    $('#loader').show();
    if (starting_product_options) {
      // on first load, option data already here
      updateOptions(starting_product_options);
      starting_product_options = false;
    } else {
      $('.quantity').show();
      $('.stockError').css('display', 'none');
      const pid = $('#product_id').val();
        // otherwise get options via Ajax
      $.ajax({
        type : 'GET',
        url : '/ajax/product/' + pid + '/option/' + selected,
        data: window.mpb.previewInfo,
        dataType : 'json'
      }).done(function(data) {
        const available_qty = parseInt(data.status.stock, 10) - (data.status.selfQty + data.status.otherQty);
        if (available_qty <= 0) {
          if (data.status.selfQty) {
            $('.stockError').html(data.status.selfMessage).show();
          } else {
            $('.stockError').html(data.status.otherMessage).show();
          }
          $('.error').hide();
          $('.quantity').hide();
          $('#q').val(0);
        } else {
          $('#q').val(1);
        }
        updateOptions(data, status);
      }).fail(function(data) {

      });
    }
  });

  $($cartOptionSelects[0]).trigger('change');

  $('.submit-to-cartOptions').on('tap click', function() {
    const qty = parseInt($('.input_spinner input').val(), 10),
      max = parseInt($('.input_spinner input').attr('alt'), 10);
    let errorOptions = false;

    $('#select_options select').each(function(index) {
      if ($(this).val() === 0) {
        errorOptions = true;
      }
    });

    if (errorOptions) {
      alert(option_error);
      return false;
    }
    if (qty === 0) {
      alert(zero_error);
      return false;
    }
    if (qty > max) {
      alert(too_many_error + ' ' + max);
      return false;
    }
  });



  function changeImageOption(img, full) {
    const full_wrapper = $('.image_full img');
    const zoom = $('.zoom_bloc .zoom');
    if ( zoom.attr('href') === img && zoom.attr('rel') === full) {
      return;
    }
    full_wrapper.animate({'opacity': 0}, 'fast', null, function() {
      full_wrapper._zoom = false;
      full_wrapper.parent().get(0).scrollLeft = 0;
      full_wrapper.parent().get(0).scrollTop = 0;
      full_wrapper.css('cursor', 'pointer');
      full_wrapper.parent().removeClass('zoom');
      zoom.attr('href', img);
      zoom.attr('rel', full);
      if (!full_wrapper.get(0)._onload) {
        full_wrapper.get(0)._onload = true;
        full_wrapper.load(function() {
          full_wrapper.animate({'opacity': 1}, 'fast');
        });
      }
      full_wrapper.attr('src', img);
    });
    return false;
  }

  // Mobile product page redesigned using bootstrap + bs alerts
  // Alerts close button
  $('.top_notification .close').on('click', function(e) {
    $(this).parent('.alert').fadeOut();
  });


  // Form add to cart mobile
  $('#frmAddToCart_mobile').on('submit', function() {

    const $this = $(this),
      id = $('#option_id', $this).val(),
      qty = parseInt($('.input_spinner input', $this).val(), 10),
      max = parseInt($('.input_spinner input', $this).attr('alt'), 10);
      const pid = $('#product_id').val();
    let errorOptions = false;

    // 1. Validate options, qty and stock
    $('#select_options select').each(function(index) {
      if ($(this).val() === 0) errorOptions = true;
    });

    if (errorOptions) return showError(option_error);
    if (qty === 0 ) return showError(zero_error);
    if (qty > max) return showError(too_many_error + ' ' + max);

    function showError(message) {
      $('#alertError #message').html(message);
      $('#alertError').fadeIn();
      setTimeout(function() {
        $('#alertError').fadeOut(1500);
      }, 5000);
      return false;
    }

    // 2. Ajax call to $cart->AddProduct($option);
    $.post('/ajax/cart/product/' + id + '/add', {qty})
      .done(function () {
        fbq('track', 'AddToCart', {
          content_type: 'product',
          content_ids: pid,
        });
      });

    // 3. Show bs alert with Added OK!
    $('#alertError').fadeOut('fast');
    $('#alertCartOK').fadeIn();
  });
  // End redesigned product page using bs.

  $('.frmAddToCart').on('submit', function() {
    const $this = $(this),
      id = $('#option_id', $this).val(),
      qty = parseInt($('.input_spinner input', $this).val(), 10),
      max = parseInt($('.input_spinner input', $this).attr('alt'), 10),
      pid = $('#product_id').val();
    let errorOptions = false;

    $('#select_options select').each(function(index) {
      if ($(this).val() === 0) {
        errorOptions = true;
      }
    });

    if (errorOptions) {
      alert(option_error);
      return false;
    }

    if (qty === 0) {
      alert(zero_error);
      return false;
    }

    if (qty > max) {
      alert(too_many_error + ' ' + max);
      return false;
    }

    $('<div class="lightbox_content_wrapper lightbox_content add-to-cart">')
      .ajaxLightbox('/ajax/cart/product/' + id + '/add', {
        data : {qty},
        callback : function(wrapper) {
          mpb.topCart.resetTimer();
          // Trigger FB pixel
          fbq('track', 'AddToCart', {
            content_type: 'product',
            content_ids: pid,
          });
        },
        errorCallback : (responseText, jqXHR) => {
          // if we've got a "user not logged in" error
          if (jqXHR.status === 401) {
            // open login box
            mpb.LP.open({redir: window.location.href});
          }
        }
      });
    return false;
  }); // end $('.frmAddToCart').submit

  if ($('#logout-button').length) {
    $('.newsletter .form_wrapper')
    .animate({'opacity': 0.3}, 200)
    .find('input').attr('disabled', true);
  }

  $('.newsletter form').on('submit', function() {
    const email = $('#newsletter_email').val();
    if (email === newsletter_email) {
      $('#newsletter_email').val('');
    }

    if (email === '') {
      return false; // email must not be empty
    }
    if (! (/^([a-zA-Z0-9_\.\-])+@(([a-zA-Z0-9\-])+\.)+([a-zA-Z0-9]{2,5})$/).test(email)) {
      alert(email + ' ' + newsletter_invalid);
      return false; // email must be valid
    }
    return $('<div>').ajaxLightbox('/ajax/register?email=' + email);
  }); // end $('.newsletter form').submit

  $('.long_description a.img-slidedown').each(function() {
    // preloading the image is necessary for the box to have correct dimensions;
    const $lnk = $(this);
    const $img = $('<img src="' + $(this).attr('href') + '" />');
    $img.one('load', function() {
      $lnk.click(function() {
        $img.css('display', 'none');
        $lnk.after('<br>', $img);
        $img.show('slow');
        return false;
      });
    }).each(function() {
      if (this.complete) $(this).load();
    });
  });

  const pad = function (n, width, z) {
    n = n + '';
    return n.length >= width ? n : new Array(width - n.length + 1).join(z || '0') + n;
  };

  mpb.FB = (function () {

    let FBLoaded = false;
    const mpbFB = {
        init,
        login,
        redirParams : {}, // { redir, refer }
    };
    return mpbFB;

    function init() {
      if (FBLoaded) return;

      const FBAppId = $('meta[property="fb:app_id"]').attr('content');

      FBLoaded = true;
      window.fbAsyncInit = function() {
      FB.init({
        appId      : FBAppId, // App ID
        version    : 'v2.5',
        status     : true, // check login status
        cookie     : true, // enable cookies to allow the server to access the session
        oauth      : true, // enable OAuth 2.0
        xfbml      : false // parse XFBML
      });
      };

      // Load the SDK Asynchronously
      (function(d, s, id) {
        if (d.getElementById(id)) return;
        const js = d.createElement(s);
        js.id = id;
        js.src = '//connect.facebook.net/en_US/sdk.js';
        const fjs = d.getElementsByTagName(s)[0];
        fjs.parentNode.insertBefore(js, fjs);
      }(document, 'script', 'facebook-jssdk'));

      return mpbFB;
    }

    function login() {
      FB.login(response => {
        if (response.authResponse) {
          window.location = '/ajax/user/fbConnect?' + $.param(mpbFB.redirParams);
        }
      }, {scope: 'email'}); // which data to access from user profile
    }
  }());

  // Login Popup
  mpb.LP = (function () {
    const LP = {
      init, // initialize what?
      open,
      isOpen : false,
      wrapper : null,
      hasBeenOpened : false,
      loginFrm : null,
      linkClick,
    };

    // window.showLP = number of seconds of delay on the page before we show the lightbox
    if (mpb.LPShowDelay) {
      window.setTimeout(() => LP.open({noReOpen : true, redir: mpb.LPRedir}), mpb.LPShowDelay * 1000);
    }

    const loginFrm = LP.loginFrm = {
      init : function () {
        this.isOpen = false;
        this.$frmDiv = $('#reg-popup .login-form', LP.wrapper);

        $('.pw-forgotten', this.$frmDiv).on('tap click', e => {
          this.close(() => LP.FPFrm.open());
          return false;
        });
      },
      open : function (email) {
      this.isOpen = true;
      this.$frmDiv.slideDown(undefined, undefined, e => {
        if (email) {
          $('.email', this.$frmDiv).val(email);
          $('.pw', this.$frmDiv).trigger('focus');
        } else {
          $('.email', this.$frmDiv).trigger('focus');
        }
      });
      },
      close : function (callback) {
        this.$frmDiv.slideUp(undefined, undefined, callback);
        this.isOpen = false;
      },
      toggle : function () {
        this[this.isOpen ? 'close' : 'open']();
        return false;
      }
    };

    const FPFrm = LP.FPFrm = {
      init : function () {
      this.isOpen = false;
      this.$frmDiv = $('#reg-popup .forgot-pw-form', LP.wrapper);
      const $frm = $('form', this.$frmDiv);
      $('.back-to-login', this.$frmDiv).on('tap click', e => {
        this.close(() => loginFrm.open());
        return false;
      });
      $frm.on('submit', e => {
        $('.errors, .message', this.$frmDiv).html('').hide();
        const show = (type) => (data => {
          const message = data.responseText
            ? JSON.parse(data.responseText).message
            : data.message;
          $('.' + type, $frm).text(message).show();
        });
        $.post('/ajax/user/newPassword', $frm.serialize(), show('message'), 'json')
          .fail(show('errors'));
        return false;
      });
      },
      open : function (email) {
        this.isOpen = true;
        this.$frmDiv.slideDown(undefined, undefined, () => {
          $('.email', this.$frmDiv).val(email).trigger('focus');
        });
      },
      close : function (callback) {
        this.$frmDiv.slideUp(undefined, undefined, callback);
        this.isOpen = false;
      },
      toggle : function () {
        this[this.isOpen ? 'close' : 'open']();
        return false;
      }
    };

    // if not logged in, any <a class='signin'> will open the login popup
    if (!mpb.auth) {
      $('a.signin').on('tap click', e => linkClick(e));
      $('div.signin').on('tap click', e => linkClick(e, true));
    }

    return LP;

    function linkClick(e, reload) {
      e.stopImmediatePropagation();
      LP.open(reload
        ? { reload : true }
        : { redir : e.currentTarget.href });
      return false;
    }

    // Show register_lightbox
    // if a popup is already opened, don't show but check again 1sec later
    function open(opts = {}) {
      if (LP.isOpen) return false;
      if ($('.jqModalDialogue').length) {
        if (LP.hasBeenOpened && opts.noReOpen) return false;
        window.setTimeout(() => open(opts), 1000);
      } else {
        LP.allowClose = opts.allowClose === undefined ? true : opts.allowClose;
        const div = opts.div || $('<div>'),
          reload = LP.reload = opts.reload || LP.reload || false,
          redir = LP.redir = opts.redir || LP.redir || '/private-sales',
          data = opts.data || {},
          allowClose = LP.allowClose,
          callback = (wrapper) => LP.init(wrapper),
          params = $.param({allowClose});

        mpb.FB.redirParams = {redir, reload};

        return div.ajaxLightbox('/ajax/login-register?' + params, {data, allowClose, callback});
      }
    }


    function reloadContent(url) {
      LP.wrapper.load(url, () => LP.init());
      return false;
    }

    // call init with wrapper when first opening a new popup
    // or without wrapper if re-initializing an existing popup after reload of content
    function init(wrapper) {
      mpb.FB.init();
      LP.hasBeenOpened = true;
      LP.wrapper = wrapper || LP.wrapper;
      loginFrm.init();
      FPFrm.init();

      // set up click event on language chooser links
      $('.language-chooser a', LP.wrapper).on('tap click', e => reloadContent(e.target.href));

      // close login-form when entering register form
      $('#register-form input', LP.wrapper).focus(e => {
        loginFrm.close();
        FPFrm.close();
      });

      // toggle login-form when clicking on login invite text
      $('.login-invite', LP.wrapper).on('tap click', e => {
        FPFrm.close(() => loginFrm.toggle());
      });

      function signinRedir(langCode) {
        const defaultLang = loginFrm.$frmDiv.data('def-lang').toLowerCase();
        if (LP.reload) {
          window.location.reload();
        } else {
          window.location = LP.redir.replace(
            /^((?:(?:https?:)?\/\/)?[a-z.]+)?(?:\/(?:en|fr|de))?([\/?].*|$)/i,
            (match, host, path) => (host || '') + '/' + (langCode || defaultLang) + path
          );
        }
      }

      const success = data => signinRedir(data.langCode);

      window.setTimeout(() => $('#register-form .email').trigger('focus'), 50);

      // sign-in and register
      $('.login-form form', LP.wrapper).on('submit', e => {
        const $frm = $(e.currentTarget),
          $errorDisplay = $('.errors', $frm).html('');
        $.post('/ajax/user/login', $frm.serialize(), undefined, 'json')
          .done(success)
          .fail(function(data) {
            const answer = JSON.parse(data.responseText);
            $errorDisplay.html(answer.message).show();
          });
        return false;
      });

      $('#register-form', LP.wrapper).on('submit', e => {
        const $frm = $(e.currentTarget),
          $errorDisplay = $('.errors', $frm).html('');
        $.post('/ajax/user/register', $frm.serialize(), undefined, 'json')
          .done(function(data) {
            // Trigger FB pixel*
            fbq('track', 'CompleteRegistration', {
              value: 1.00,
              currency: 'CHF'
            });
            signinRedir(data.langCode);
          })
          .fail(function(data) {
            const answer = JSON.parse(data.responseText);
            $errorDisplay.html(answer.message).show();
            if (answer.errCode === 'accountExists') {
              loginFrm.open($('.email', $frm).val());
            }
          });
        return false;
      });
    }
  } ($));

  // export cart to global scope on mpb object
  mpb.topCart = (function () {
    const // private vars
      // IDs of spans for cart amount and timer
      $timer = $('#timer'),
      $expireTxt = $('.expire-text'),
      $amount = $('#cart_total > .amount'),
      // number of seconds left on pageLoad
      timeLeft = $timer.data('timeleft'),
      lifeSpan = $timer.data('lifespan'),
      // cart object for export
      cart = {
        setAmount : setAmount,
        resetTimer: resetTimer,
        resetServerTimer : resetServerTimer,
        set onTimeout(h) { timeoutHandler = h; },
        get onTimeout() { return timeoutHandler; }
      };
    let // current number of seconds left
      seconds = timeLeft,
      step = 1,
      checkAtSeconds = [5, 30, 60, 120, 240],
      // id of current timeout
      timeout = null,
      timeoutHandler = checkSeconds;

    // If we have seconds to go, and we have a timer to show those seconds, start the timer!
    if ($timer.length && seconds) setCartTimeout();

    return cart;

    function setAmount(n) {
      $amount.text(mpb.format_number(n, true));
      return this;
    }

    // updates seconds display to given s and clears timeout
    function setSeconds(s, expired) {
      if (timeout) {
        clearTimeout(timeout);
        timeout = 0;
      }
      seconds = s;
      if (s) {
        if (checkAtSeconds.some(function(cs) { return cs === seconds; })) {
          checkSeconds();
        }
        $timer.html(pad(Math.floor(s / 60, 0), 2) + ':' + pad(s % 60, 2)).show();
        $expireTxt.html($expireTxt.data('expInTxt')).show();
      } else {
        if (window.location.pathname.match('/creditcard')) {
          window.location = '/cart/shipping/6';
        }
        $timer.hide();
        $expireTxt.html($expireTxt.data('expdTxt'))[expired ? 'show' : 'hide']();
      }
      return this;
    }

    function checkSeconds(expired) {
      if (!expired) {
      $.get('/ajax/cart/secondsLeft')
        .done(function (data) {
          if (!data.seconds || seconds !== data.seconds) {
            setCartTimeout(data.seconds, data.expired);
          }
        });
      }
    }

    // if s is falsy, resets timer to maximum lifeSpan
    function resetServerTimer() {
      return $.get('/ajax/cart/resetTimer')
        .done(data => {
          if (data.expired) {
            setAmount(0);
            setSeconds(0, true);
          } else {
            resetTimer();
          }
          data.seconds = seconds;
        });
    }

    // if s is falsy, resets timer to maximum lifeSpan
    function resetTimer(s, expired) {
      setCartTimeout(s === undefined ? lifeSpan : s, expired);
    }

    // set timer to specific number of seconds.
    function setCartTimeout(s, expired) {
      // if s is not provided, default to seconds
      setSeconds(s === undefined ? seconds : (seconds = s), expired);
      if (s === 0) {
        setAmount(0);
        timeoutHandler(expired);
      } else {
        timeout = window.setTimeout(function () {
          setCartTimeout(Math.max(0, seconds - step));
        }, 1000);
      }
    }
  }());

  mpb.openCtryRedirBox = openCtryRedirBox;
  function openCtryRedirBox() {
    if ($('.jqModalDialogue').length) {
      window.setTimeout(openCtryRedirBox, 1000);
    } else {
      const callback = (wrapper) => {
        $('#no-thanks', wrapper).on('click', e => {
          document.cookie = 'ctryChk=1;path=/';
          $('.ui-dialog-content').dialog('close');
        });
      };
      return $('<div>').ajaxLightbox('/ajax/country-choice', { callback });
    }
  }

  $('div.acct_nav')
    .on('click', function(e) { $(this).toggleClass('hover'); });

  $('#login_btn')
    .on('click', function(e) {
      if ($('#forgot_pwd').is(':visible')) {
        $('#forgot_pwd').slideUp();
      } else {
        $('#login_box').slideToggle();
        $('#login_box .email').trigger('focus');
        mpb.FB.init();
        e.stopImmediatePropagation();
      }
    });

  $('.pw-forgotten')
    .on('click', function(e) {
      $('#login_box').slideUp('fast', function() {
        $('#forgot_pwd').slideDown('fast');
        $('#forgot_pwd .email').trigger('focus');
      })
    });

  $('.back-to-login')
    .on('click', function(e) {
      $('#forgot_pwd').slideUp('fast', function() {$('#login_box').slideDown('fast'); })
    });

  $('#login_box .register')
    .on('click', function(e) {
      $('#login_box').slideUp('fast', function() {
        e.stopImmediatePropagation();
        mpb.LP.open();
        return false;
      });
    });

  // Login (header)
  $('#login_box form').on('submit', e => {
    const $frm = $(e.currentTarget),
      $errorDisplay = $('.errors', $frm).html('');
    $.post('/ajax/user/login', $frm.serialize(), undefined, 'json')
      .done(() => location.reload())
      .fail((data) => {
        const answer = JSON.parse(data.responseText);
        $errorDisplay.html(answer.message).show();
      });
    return false;
  });

  // Password request (header)
  $('#forgot_pwd form').on('submit', e => {
    const $frm = $(e.currentTarget);
    $('.errors, .message', $frm).html('').hide();
    const show = (type) => (data => {
      const message = data.responseText
        ? JSON.parse(data.responseText).message
        : data.message;
      $('.' + type, $frm).text(message).show();
    });
    $.post('/ajax/user/newPassword', $frm.serialize(), show('message'), 'json')
      .fail(show('errors'));
    return false;
  });

  if (document.getElementById('size-guide-trigger')) {

    (function() {
      $(document).on('click', '#size-guide-trigger', function(e) {
        const $this = $(this);
        const heading = $this.data('heading');
        const target = $this.data('target');
        $(`<div class="size-guide-box" style="min-width:900px">
            <h1 class="size-guide-box-title">${heading}</h1>
            <div class="size-guide-box-container">
            <iframe src="${target}" width="900" height="600" frameborder="0" style="border:0" allowfullscreen></iframe>
            </div>
          </div>
        `).elemLightbox();
      });
    })();
  }

  ////// Back-In-Stock buttons //////
  (() => {
    const $bisnDiv = $('.back-in-stock');
    const bellClass = { false: 'fa-bell-slash-o', true: 'fa-bell' };
    // adjust visual state of button
    function updateBtnState($div, isOn) {
      $('i', $div.show()).removeClass(bellClass[!isOn]).addClass(bellClass[!!isOn]);
    }

    // Initialize button states after page load, if states are available
    // if states are given on loading page, apply them immediately
    if (mpb.BISN_pidsByState) {
      // get a catalogue of BISN DIVs by PID: {[pid] : div}
      const btnIdx = $bisnDiv.toArray().reduce((acc, el) => Object.assign(acc, {[$(el).data('pid')]: el}), {});
      // foreach state (0=false, 1=true) call updateState(btn, state) on each BISN DIV button
      [0, 1].forEach(state => mpb.BISN_pidsByState[state].forEach(pid => updateBtnState($(btnIdx[pid]), !!state)));
    }

    // respond to click by uploading toggle request, then adjusting state according to response
    $bisnDiv.on('click', function() {
      $.ajax({
        url: `/api/v3/catalogue/product/${$(this).data('pid')}/toggleBISN`,
        dataType: 'json',
        type: 'POST',
      }).then(responseData => updateBtnState($(this), responseData.subscribed));
    })
  })();
  ///////////////////////////////////

  if (document.getElementById('js-look')) {
    const $brands = $('#js-look-brands');
    const $types = $('#js-look-types');
    const latin_map = {
      'Á': 'A', 'Ă': 'A', 'Ắ': 'A', 'Ặ': 'A', 'Ằ': 'A', 'Ẳ': 'A', 'Ẵ': 'A', 'Ǎ': 'A', 'Â': 'A', 'Ấ': 'A', 'Ậ': 'A', 'Ầ': 'A',
      'Ẩ': 'A', 'Ẫ': 'A', 'Ä': 'A', 'Ǟ': 'A', 'Ȧ': 'A', 'Ǡ': 'A', 'Ạ': 'A', 'Ȁ': 'A', 'À': 'A', 'Ả': 'A', 'Ȃ': 'A', 'Ā': 'A',
      'Ą': 'A', 'Å': 'A', 'Ǻ': 'A', 'Ḁ': 'A', 'Ⱥ': 'A', 'Ã': 'A', 'Ꜳ': 'AA', 'Æ': 'AE', 'Ǽ': 'AE', 'Ǣ': 'AE', 'Ꜵ': 'AO', 'Ꜷ': 'AU',
      'Ꜹ': 'AV', 'Ꜻ': 'AV', 'Ꜽ': 'AY', 'Ḃ': 'B', 'Ḅ': 'B', 'Ɓ': 'B', 'Ḇ': 'B', 'Ƀ': 'B', 'Ƃ': 'B', 'Ć': 'C', 'Č': 'C', 'Ç': 'C',
      'Ḉ': 'C', 'Ĉ': 'C', 'Ċ': 'C', 'Ƈ': 'C', 'Ȼ': 'C', 'Ď': 'D', 'Ḑ': 'D', 'Ḓ': 'D', 'Ḋ': 'D', 'Ḍ': 'D', 'Ɗ': 'D', 'Ḏ': 'D',
      'ǲ': 'D', 'ǅ': 'D', 'Đ': 'D', 'Ƌ': 'D', 'Ǳ': 'DZ', 'Ǆ': 'DZ', 'É': 'E', 'Ĕ': 'E', 'Ě': 'E', 'Ȩ': 'E', 'Ḝ': 'E', 'Ê': 'E',
      'Ế': 'E', 'Ệ': 'E', 'Ề': 'E', 'Ể': 'E', 'Ễ': 'E', 'Ḙ': 'E', 'Ë': 'E', 'Ė': 'E', 'Ẹ': 'E', 'Ȅ': 'E', 'È': 'E', 'Ẻ': 'E',
      'Ȇ': 'E', 'Ē': 'E', 'Ḗ': 'E', 'Ḕ': 'E', 'Ę': 'E', 'Ɇ': 'E', 'Ẽ': 'E', 'Ḛ': 'E', 'Ꝫ': 'ET', 'Ḟ': 'F', 'Ƒ': 'F', 'Ǵ': 'G',
      'Ğ': 'G', 'Ǧ': 'G', 'Ģ': 'G', 'Ĝ': 'G', 'Ġ': 'G', 'Ɠ': 'G', 'Ḡ': 'G', 'Ǥ': 'G', 'Ḫ': 'H', 'Ȟ': 'H', 'Ḩ': 'H', 'Ĥ': 'H',
      'Ⱨ': 'H', 'Ḧ': 'H', 'Ḣ': 'H', 'Ḥ': 'H', 'Ħ': 'H', 'Í': 'I', 'Ĭ': 'I', 'Ǐ': 'I', 'Î': 'I', 'Ï': 'I', 'Ḯ': 'I', 'İ': 'I',
      'Ị': 'I', 'Ȉ': 'I', 'Ì': 'I', 'Ỉ': 'I', 'Ȋ': 'I', 'Ī': 'I', 'Į': 'I', 'Ɨ': 'I', 'Ĩ': 'I', 'Ḭ': 'I', 'Ꝺ': 'D', 'Ꝼ': 'F',
      'Ᵹ': 'G', 'Ꞃ': 'R', 'Ꞅ': 'S', 'Ꞇ': 'T', 'Ꝭ': 'IS', 'Ĵ': 'J', 'Ɉ': 'J', 'Ḱ': 'K', 'Ǩ': 'K', 'Ķ': 'K', 'Ⱪ': 'K', 'Ꝃ': 'K',
      'Ḳ': 'K', 'Ƙ': 'K', 'Ḵ': 'K', 'Ꝁ': 'K', 'Ꝅ': 'K', 'Ĺ': 'L', 'Ƚ': 'L', 'Ľ': 'L', 'Ļ': 'L', 'Ḽ': 'L', 'Ḷ': 'L', 'Ḹ': 'L',
      'Ⱡ': 'L', 'Ꝉ': 'L', 'Ḻ': 'L', 'Ŀ': 'L', 'Ɫ': 'L', 'ǈ': 'L', 'Ł': 'L', 'Ǉ': 'LJ', 'Ḿ': 'M', 'Ṁ': 'M', 'Ṃ': 'M', 'Ɱ': 'M',
      'Ń': 'N', 'Ň': 'N', 'Ņ': 'N', 'Ṋ': 'N', 'Ṅ': 'N', 'Ṇ': 'N', 'Ǹ': 'N', 'Ɲ': 'N', 'Ṉ': 'N', 'Ƞ': 'N', 'ǋ': 'N', 'Ñ': 'N',
      'Ǌ': 'NJ', 'Ó': 'O', 'Ŏ': 'O', 'Ǒ': 'O', 'Ô': 'O', 'Ố': 'O', 'Ộ': 'O', 'Ồ': 'O', 'Ổ': 'O', 'Ỗ': 'O', 'Ö': 'O', 'Ȫ': 'O',
      'Ȯ': 'O', 'Ȱ': 'O', 'Ọ': 'O', 'Ő': 'O', 'Ȍ': 'O', 'Ò': 'O', 'Ỏ': 'O', 'Ơ': 'O', 'Ớ': 'O', 'Ợ': 'O', 'Ờ': 'O', 'Ở': 'O',
      'Ỡ': 'O', 'Ȏ': 'O', 'Ꝋ': 'O', 'Ꝍ': 'O', 'Ō': 'O', 'Ṓ': 'O', 'Ṑ': 'O', 'Ɵ': 'O', 'Ǫ': 'O', 'Ǭ': 'O', 'Ø': 'O', 'Ǿ': 'O',
      'Õ': 'O', 'Ṍ': 'O', 'Ṏ': 'O', 'Ȭ': 'O', 'Ƣ': 'OI', 'Ꝏ': 'OO', 'Ɛ': 'E', 'Ɔ': 'O', 'Ȣ': 'OU', 'Ṕ': 'P', 'Ṗ': 'P', 'Ꝓ': 'P',
      'Ƥ': 'P', 'Ꝕ': 'P', 'Ᵽ': 'P', 'Ꝑ': 'P', 'Ꝙ': 'Q', 'Ꝗ': 'Q', 'Ŕ': 'R', 'Ř': 'R', 'Ŗ': 'R', 'Ṙ': 'R', 'Ṛ': 'R', 'Ṝ': 'R',
      'Ȑ': 'R', 'Ȓ': 'R', 'Ṟ': 'R', 'Ɍ': 'R', 'Ɽ': 'R', 'Ꜿ': 'C', 'Ǝ': 'E', 'Ś': 'S', 'Ṥ': 'S', 'Š': 'S', 'Ṧ': 'S', 'Ş': 'S',
      'Ŝ': 'S', 'Ș': 'S', 'Ṡ': 'S', 'Ṣ': 'S', 'Ṩ': 'S', 'ẞ': 'SS', 'Ť': 'T', 'Ţ': 'T', 'Ṱ': 'T', 'Ț': 'T', 'Ⱦ': 'T', 'Ṫ': 'T',
      'Ṭ': 'T', 'Ƭ': 'T', 'Ṯ': 'T', 'Ʈ': 'T', 'Ŧ': 'T', 'Ɐ': 'A', 'Ꞁ': 'L', 'Ɯ': 'M', 'Ʌ': 'V', 'Ꜩ': 'TZ', 'Ú': 'U', 'Ŭ': 'U',
      'Ǔ': 'U', 'Û': 'U', 'Ṷ': 'U', 'Ü': 'U', 'Ǘ': 'U', 'Ǚ': 'U', 'Ǜ': 'U', 'Ǖ': 'U', 'Ṳ': 'U', 'Ụ': 'U', 'Ű': 'U', 'Ȕ': 'U',
      'Ù': 'U', 'Ủ': 'U', 'Ư': 'U', 'Ứ': 'U', 'Ự': 'U', 'Ừ': 'U', 'Ử': 'U', 'Ữ': 'U', 'Ȗ': 'U', 'Ū': 'U', 'Ṻ': 'U', 'Ų': 'U',
      'Ů': 'U', 'Ũ': 'U', 'Ṹ': 'U', 'Ṵ': 'U', 'Ꝟ': 'V', 'Ṿ': 'V', 'Ʋ': 'V', 'Ṽ': 'V', 'Ꝡ': 'VY', 'Ẃ': 'W', 'Ŵ': 'W', 'Ẅ': 'W',
      'Ẇ': 'W', 'Ẉ': 'W', 'Ẁ': 'W', 'Ⱳ': 'W', 'Ẍ': 'X', 'Ẋ': 'X', 'Ý': 'Y', 'Ŷ': 'Y', 'Ÿ': 'Y', 'Ẏ': 'Y', 'Ỵ': 'Y', 'Ỳ': 'Y',
      'Ƴ': 'Y', 'Ỷ': 'Y', 'Ỿ': 'Y', 'Ȳ': 'Y', 'Ɏ': 'Y', 'Ỹ': 'Y', 'Ź': 'Z', 'Ž': 'Z', 'Ẑ': 'Z', 'Ⱬ': 'Z', 'Ż': 'Z', 'Ẓ': 'Z',
      'Ȥ': 'Z', 'Ẕ': 'Z', 'Ƶ': 'Z', 'Ĳ': 'IJ', 'Œ': 'OE', 'ᴀ': 'A', 'ᴁ': 'AE', 'ʙ': 'B', 'ᴃ': 'B', 'ᴄ': 'C', 'ᴅ': 'D', 'ᴇ': 'E',
      'ꜰ': 'F', 'ɢ': 'G', 'ʛ': 'G', 'ʜ': 'H', 'ɪ': 'I', 'ʁ': 'R', 'ᴊ': 'J', 'ᴋ': 'K', 'ʟ': 'L', 'ᴌ': 'L', 'ᴍ': 'M', 'ɴ': 'N',
      'ᴏ': 'O', 'ɶ': 'OE', 'ᴐ': 'O', 'ᴕ': 'OU', 'ᴘ': 'P', 'ʀ': 'R', 'ᴎ': 'N', 'ᴙ': 'R', 'ꜱ': 'S', 'ᴛ': 'T', 'ⱻ': 'E', 'ᴚ': 'R',
      'ᴜ': 'U', 'ᴠ': 'V', 'ᴡ': 'W', 'ʏ': 'Y', 'ᴢ': 'Z', 'á': 'a', 'ă': 'a', 'ắ': 'a', 'ặ': 'a', 'ằ': 'a', 'ẳ': 'a', 'ẵ': 'a',
      'ǎ': 'a', 'â': 'a', 'ấ': 'a', 'ậ': 'a', 'ầ': 'a', 'ẩ': 'a', 'ẫ': 'a', 'ä': 'a', 'ǟ': 'a', 'ȧ': 'a', 'ǡ': 'a', 'ạ': 'a',
      'ȁ': 'a', 'à': 'a', 'ả': 'a', 'ȃ': 'a', 'ā': 'a', 'ą': 'a', 'ᶏ': 'a', 'ẚ': 'a', 'å': 'a', 'ǻ': 'a', 'ḁ': 'a', 'ⱥ': 'a',
      'ã': 'a', 'ꜳ': 'aa', 'æ': 'ae', 'ǽ': 'ae', 'ǣ': 'ae', 'ꜵ': 'ao', 'ꜷ': 'au', 'ꜹ': 'av', 'ꜻ': 'av', 'ꜽ': 'ay', 'ḃ': 'b',
      'ḅ': 'b', 'ɓ': 'b', 'ḇ': 'b', 'ᵬ': 'b', 'ᶀ': 'b', 'ƀ': 'b', 'ƃ': 'b', 'ɵ': 'o', 'ć': 'c', 'č': 'c', 'ç': 'c', 'ḉ': 'c',
      'ĉ': 'c', 'ɕ': 'c', 'ċ': 'c', 'ƈ': 'c', 'ȼ': 'c', 'ď': 'd', 'ḑ': 'd', 'ḓ': 'd', 'ȡ': 'd', 'ḋ': 'd', 'ḍ': 'd', 'ɗ': 'd',
      'ᶑ': 'd', 'ḏ': 'd', 'ᵭ': 'd', 'ᶁ': 'd', 'đ': 'd', 'ɖ': 'd', 'ƌ': 'd', 'ı': 'i', 'ȷ': 'j', 'ɟ': 'j', 'ʄ': 'j', 'ǳ': 'dz',
      'ǆ': 'dz', 'é': 'e', 'ĕ': 'e', 'ě': 'e', 'ȩ': 'e', 'ḝ': 'e', 'ê': 'e', 'ế': 'e', 'ệ': 'e', 'ề': 'e', 'ể': 'e', 'ễ': 'e',
      'ḙ': 'e', 'ë': 'e', 'ė': 'e', 'ẹ': 'e', 'ȅ': 'e', 'è': 'e', 'ẻ': 'e', 'ȇ': 'e', 'ē': 'e', 'ḗ': 'e', 'ḕ': 'e', 'ⱸ': 'e',
      'ę': 'e', 'ᶒ': 'e', 'ɇ': 'e', 'ẽ': 'e', 'ḛ': 'e', 'ꝫ': 'et', 'ḟ': 'f', 'ƒ': 'f', 'ᵮ': 'f', 'ᶂ': 'f', 'ǵ': 'g', 'ğ': 'g',
      'ǧ': 'g', 'ģ': 'g', 'ĝ': 'g', 'ġ': 'g', 'ɠ': 'g', 'ḡ': 'g', 'ᶃ': 'g', 'ǥ': 'g', 'ḫ': 'h', 'ȟ': 'h', 'ḩ': 'h', 'ĥ': 'h',
      'ⱨ': 'h', 'ḧ': 'h', 'ḣ': 'h', 'ḥ': 'h', 'ɦ': 'h', 'ẖ': 'h', 'ħ': 'h', 'ƕ': 'hv', 'í': 'i', 'ĭ': 'i', 'ǐ': 'i', 'î': 'i',
      'ï': 'i', 'ḯ': 'i', 'ị': 'i', 'ȉ': 'i', 'ì': 'i', 'ỉ': 'i', 'ȋ': 'i', 'ī': 'i', 'į': 'i', 'ᶖ': 'i', 'ɨ': 'i', 'ĩ': 'i',
      'ḭ': 'i', 'ꝺ': 'd', 'ꝼ': 'f', 'ᵹ': 'g', 'ꞃ': 'r', 'ꞅ': 's', 'ꞇ': 't', 'ꝭ': 'is', 'ǰ': 'j', 'ĵ': 'j', 'ʝ': 'j', 'ɉ': 'j',
      'ḱ': 'k', 'ǩ': 'k', 'ķ': 'k', 'ⱪ': 'k', 'ꝃ': 'k', 'ḳ': 'k', 'ƙ': 'k', 'ḵ': 'k', 'ᶄ': 'k', 'ꝁ': 'k', 'ꝅ': 'k', 'ĺ': 'l',
      'ƚ': 'l', 'ɬ': 'l', 'ľ': 'l', 'ļ': 'l', 'ḽ': 'l', 'ȴ': 'l', 'ḷ': 'l', 'ḹ': 'l', 'ⱡ': 'l', 'ꝉ': 'l', 'ḻ': 'l', 'ŀ': 'l',
      'ɫ': 'l', 'ᶅ': 'l', 'ɭ': 'l', 'ł': 'l', 'ǉ': 'lj', 'ſ': 's', 'ẜ': 's', 'ẛ': 's', 'ẝ': 's', 'ḿ': 'm', 'ṁ': 'm', 'ṃ': 'm',
      'ɱ': 'm', 'ᵯ': 'm', 'ᶆ': 'm', 'ń': 'n', 'ň': 'n', 'ņ': 'n', 'ṋ': 'n', 'ȵ': 'n', 'ṅ': 'n', 'ṇ': 'n', 'ǹ': 'n', 'ɲ': 'n',
      'ṉ': 'n', 'ƞ': 'n', 'ᵰ': 'n', 'ᶇ': 'n', 'ɳ': 'n', 'ñ': 'n', 'ǌ': 'nj', 'ó': 'o', 'ŏ': 'o', 'ǒ': 'o', 'ô': 'o', 'ố': 'o',
      'ộ': 'o', 'ồ': 'o', 'ổ': 'o', 'ỗ': 'o', 'ö': 'o', 'ȫ': 'o', 'ȯ': 'o', 'ȱ': 'o', 'ọ': 'o', 'ő': 'o', 'ȍ': 'o', 'ò': 'o',
      'ỏ': 'o', 'ơ': 'o', 'ớ': 'o', 'ợ': 'o', 'ờ': 'o', 'ở': 'o', 'ỡ': 'o', 'ȏ': 'o', 'ꝋ': 'o', 'ꝍ': 'o', 'ⱺ': 'o', 'ō': 'o',
      'ṓ': 'o', 'ṑ': 'o', 'ǫ': 'o', 'ǭ': 'o', 'ø': 'o', 'ǿ': 'o', 'õ': 'o', 'ṍ': 'o', 'ṏ': 'o', 'ȭ': 'o', 'ƣ': 'oi', 'ꝏ': 'oo',
      'ɛ': 'e', 'ᶓ': 'e', 'ɔ': 'o', 'ᶗ': 'o', 'ȣ': 'ou', 'ṕ': 'p', 'ṗ': 'p', 'ꝓ': 'p', 'ƥ': 'p', 'ᵱ': 'p', 'ᶈ': 'p', 'ꝕ': 'p',
      'ᵽ': 'p', 'ꝑ': 'p', 'ꝙ': 'q', 'ʠ': 'q', 'ɋ': 'q', 'ꝗ': 'q', 'ŕ': 'r', 'ř': 'r', 'ŗ': 'r', 'ṙ': 'r', 'ṛ': 'r', 'ṝ': 'r',
      'ȑ': 'r', 'ɾ': 'r', 'ᵳ': 'r', 'ȓ': 'r', 'ṟ': 'r', 'ɼ': 'r', 'ᵲ': 'r', 'ᶉ': 'r', 'ɍ': 'r', 'ɽ': 'r', 'ↄ': 'c', 'ꜿ': 'c',
      'ɘ': 'e', 'ɿ': 'r', 'ś': 's', 'ṥ': 's', 'š': 's', 'ṧ': 's', 'ş': 's', 'ŝ': 's', 'ș': 's', 'ṡ': 's', 'ṣ': 's', 'ṩ': 's',
      'ʂ': 's', 'ᵴ': 's', 'ᶊ': 's', 'ȿ': 's', 'ɡ': 'g', 'ß': 'ss', 'ᴑ': 'o', 'ᴓ': 'o', 'ᴝ': 'u', 'ť': 't', 'ţ': 't', 'ṱ': 't',
      'ț': 't', 'ȶ': 't', 'ẗ': 't', 'ⱦ': 't', 'ṫ': 't', 'ṭ': 't', 'ƭ': 't', 'ṯ': 't', 'ᵵ': 't', 'ƫ': 't', 'ʈ': 't', 'ŧ': 't',
      'ᵺ': 'th', 'ɐ': 'a', 'ᴂ': 'ae', 'ǝ': 'e', 'ᵷ': 'g', 'ɥ': 'h', 'ʮ': 'h', 'ʯ': 'h', 'ᴉ': 'i', 'ʞ': 'k', 'ꞁ': 'l', 'ɯ': 'm',
      'ɰ': 'm', 'ᴔ': 'oe', 'ɹ': 'r', 'ɻ': 'r', 'ɺ': 'r', 'ⱹ': 'r', 'ʇ': 't', 'ʌ': 'v', 'ʍ': 'w', 'ʎ': 'y', 'ꜩ': 'tz', 'ú': 'u',
      'ŭ': 'u', 'ǔ': 'u', 'û': 'u', 'ṷ': 'u', 'ü': 'u', 'ǘ': 'u', 'ǚ': 'u', 'ǜ': 'u', 'ǖ': 'u', 'ṳ': 'u', 'ụ': 'u', 'ű': 'u',
      'ȕ': 'u', 'ù': 'u', 'ủ': 'u', 'ư': 'u', 'ứ': 'u', 'ự': 'u', 'ừ': 'u', 'ử': 'u', 'ữ': 'u', 'ȗ': 'u', 'ū': 'u', 'ṻ': 'u',
      'ų': 'u', 'ᶙ': 'u', 'ů': 'u', 'ũ': 'u', 'ṹ': 'u', 'ṵ': 'u', 'ᵫ': 'ue', 'ꝸ': 'um', 'ⱴ': 'v', 'ꝟ': 'v', 'ṿ': 'v', 'ʋ': 'v',
      'ᶌ': 'v', 'ⱱ': 'v', 'ṽ': 'v', 'ꝡ': 'vy', 'ẃ': 'w', 'ŵ': 'w', 'ẅ': 'w', 'ẇ': 'w', 'ẉ': 'w', 'ẁ': 'w', 'ⱳ': 'w', 'ẘ': 'w',
      'ẍ': 'x', 'ẋ': 'x', 'ᶍ': 'x', 'ý': 'y', 'ŷ': 'y', 'ÿ': 'y', 'ẏ': 'y', 'ỵ': 'y', 'ỳ': 'y', 'ƴ': 'y', 'ỷ': 'y', 'ỿ': 'y',
      'ȳ': 'y', 'ẙ': 'y', 'ɏ': 'y', 'ỹ': 'y', 'ź': 'z', 'ž': 'z', 'ẑ': 'z', 'ʑ': 'z', 'ⱬ': 'z', 'ż': 'z', 'ẓ': 'z', 'ȥ': 'z',
      'ẕ': 'z', 'ᵶ': 'z', 'ᶎ': 'z', 'ʐ': 'z', 'ƶ': 'z', 'ɀ': 'z', 'ﬀ': 'ff', 'ﬃ': 'ffi', 'ﬄ': 'ffl', 'ﬁ': 'fi', 'ﬂ': 'fl',
      'ĳ': 'ij', 'œ': 'oe', 'ﬆ': 'st', 'ₐ': 'a', 'ₑ': 'e', 'ᵢ': 'i', 'ⱼ': 'j', 'ₒ': 'o', 'ᵣ': 'r', 'ᵤ': 'u', 'ᵥ': 'v', 'ₓ': 'x'
    };

    function latinise(term) {
      return term.replace(/[^A-Za-z0-9]/g,
        function(x) {
        return latin_map[x] || x;
      });
    }

    (function() {

      const $brandsList = $('#js-look-brands-list');
      const $typesList = $('#js-look-types-list');

      const look = (term) => {

        const cleanedUpTerm = latinise(`${term}`);

        $.get(`/${mpb.langCode}/api/v2/inquiry/tree/${cleanedUpTerm}`, data => {

          const brandsFragment = document.createDocumentFragment();
          const typesFragment = document.createDocumentFragment();

          $brands.hide();
          $types.hide();
          $brandsList.get(0).innerText = $typesList.get(0).innerText = ''

          if (!data) return;

          if (data.brands) {
            $brands.show();

            data.brands.forEach(brand => {
              const el = document.createElement('li');
              el.innerHTML = `<a href="${brand.url}">${brand.name}</a>`;
              brandsFragment.appendChild(el);
            });

            $brandsList.get(0).appendChild(brandsFragment);
          }

          if (data.types) {
            $types.show();

            data.types.forEach(type => {
              const el = document.createElement('li');
              el.innerHTML = `<a href="${type.url}">${type.name}</a>`;
              typesFragment.appendChild(el);
            });

            $typesList.get(0).appendChild(typesFragment);
          }
        });
      }

      function test(e) {
        const $input = $(e.target), $pane = $('#js-look-for-feature-pane');

        if ($input.val().length < 3) {
          return $($pane, $types, $brands).hide();
        }

        look($input.val());
        $pane.show();
      }

      $(document).on('keyup', '#js-look', mpb.debounce(test, 200));

      $(document).on('click', function(e) {
          const $target = $(e.target);

          if ($target && !$target.closest('#js-look-for-feature-pane').length && $('#js-look-for-feature-pane').is(':visible')) {
            $('#js-look-for-feature-pane').hide();
          }

      });

      $(document).on('keydown', '.look-for-feature', (e) => {

        const key = e.which;

        if (key !== 40 && key !== 38 ) return;

        e.preventDefault();

        const $lis = $('#js-look-for-feature-pane li');
        const $active = $lis.filter('.active');
        let   index = $lis.index($active);

        if (index >= $lis.length - 1) {
          index = -1;
        }

        $active.removeClass('active');

        $lis.eq(key === 40 ? ++index : --index).addClass('active').children('a').trigger('focus');

      });
    })();
  }
});
